module.exports = __webpack_public_path__ + "img/close.a431413b.svg";